module.exports = __webpack_public_path__ + "./fonts/TitanOne-Regular.ttf";